<template>
  <v-card>
    <v-card-title>
      {{ __("Documentos solicitados") }}
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="handleClickNewMultiple()" small>
        <v-icon left small>mdi-plus</v-icon>
        {{ __("Adicionar") }}
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row class="py-2">
        <v-col cols="12" class="text-right">
          <v-btn
            @click="handleClickCompleteReceiptMultiple()"
            text
            small
            color="info"
            :disabled="!canRegisterMultiple"
          >
            <v-icon left small>mdi-checkbox-marked-circle</v-icon>
            {{ __("Concluir recebimento") }}
          </v-btn>

          <v-btn
            @click="handleClickUndoReceiptMultiple()"
            text
            small
            color="info"
            :disabled="!canUndoMultiple"
          >
            <v-icon left small>mdi-undo</v-icon>
            {{ __("Desfazer recebimento") }}
          </v-btn>

          <v-btn
            @click="handleClickDeleteMultiple()"
            text
            small
            color="error"
            :disabled="!canDeleteMultiple"
          >
            <v-icon left small>mdi-delete</v-icon>
            {{ __("Excluir") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>

      <v-data-table
        :headers="headers"
        :items="documents"
        item-key="id"
        dense
        hide-default-footer
        show-select
        v-model="selected"
        @click:row="handleClickUpdate"
      >
        <template v-slot:item.category="{ item }">
          {{ item?.category?.name || "—" }}
        </template>

        <template v-slot:item.request_date="{ item }">
          {{ formatDate(item?.request_date) || "—" }}
        </template>

        <template v-slot:item.receipt_date="{ item }">
          <div class="d-flex align-center">
            <template v-if="item?.receipt_date">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="primary--text"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="handleClickUndoReceipt(item)"
                  >
                    <v-icon>mdi-undo</v-icon>
                  </v-btn>
                </template>
                <span>{{ __("Desfazer recebimento") }}</span>
              </v-tooltip>

              <span>{{ formatDate(item?.receipt_date) }}</span>
            </template>
            <template v-else> --- </template>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import i18n from "@/mixins/i18n";
import { formatDate } from "@/tools/date";

export default {
  mixins: [i18n],

  components: {},

  props: {
    documents: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selected: [],
      formatDate,
      headers: [
        { text: this.__("Anexo", "products"), value: "category" },
        {
          text: this.__("Data da solicitação", "products"),
          value: "request_date",
        },
        {
          text: this.__("Data de recebimento", "products"),
          value: "receipt_date",
        },
      ],
    };
  },

  methods: {
    handleClickCompleteReceiptMultiple() {
      this.$emit("click:completeReceiptMultiple", this.selected);
    },
    handleClickUndoReceiptMultiple() {
      this.$emit("click:undoReceiptMultiple", this.selected);
    },
    handleClickDeleteMultiple() {
      this.$emit("click:deleteMultiple", this.selected);
    },
    handleClickUpdate(item) {
      this.$emit("click:update", item);
    },
    handleClickUndoReceipt(item) {
      this.$emit("click:undoReceipt", item);
    },
    unselectAll() {
      this.selected = [];
    },
    handleClickNewMultiple() {
      this.$emit("click:newMultiple");
    },
  },

  computed: {
    canRegisterMultiple() {
      return this.selected.length > 0;
    },
    canUndoMultiple() {
      return (
        this.selected.length > 0 &&
        this.selected.some((doc) => doc.receipt_date)
      );
    },
    canDeleteMultiple() {
      return this.selected.length > 0;
    },
  },
};
</script>
